"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBFileField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class DBFileField extends EditorFieldBase_1.EditorFieldBase {
}
exports.DBFileField = DBFileField;
